import { render, staticRenderFns } from "./PlacesIndex.vue?vue&type=template&id=75cf2cde&"
import script from "./PlacesIndex.vue?vue&type=script&lang=js&"
export * from "./PlacesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports